import { msg } from "@lingui/core/macro";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppLayout } from "~/components/layouts/app";
import { useUser } from "~/hooks/use-session";
import { seo } from "~/modules/page/seo";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute("/_app/manager")({
	component: Page,
	async loader({ context }) {
		context.queryClient.prefetchQuery(context.trpc.channel.list.queryOptions());
	},
	head: ({ match }) => ({
		meta: [
			...seo({
				title: `${match.context.i18n._(msg`All Podcasts`)} | Azerion`,
				description: "Host & Monetize your podcasts.",
			}),
		],
	}),
});

function Page() {
	const trpc = useTRPC();
	const { user } = useUser();

	const channelsQuery = useQuery(trpc.channel.list.queryOptions());

	return (
		<AppLayout channel={null} channels={channelsQuery.data} user={user}>
			<Outlet />
		</AppLayout>
	);
}
